import moment from 'moment';

const parseCouponPromoText = (action, computedTriggerLabel,
    computedBaseOn,
    couponLimit,
    computedTriggerAmount,
    couponPrintAsOne = false, promoText) => {
    // params: <couponPrintAsOne>,<computedTriggerAmount>,<datenow>,<computedBaseOn>,N,0,<couponLimit>,A
    // ex: PRINTONCE,200,05/03/2026,S,N,0,2,A

    // <computedTriggerAmount>,<datenow>,<computedBaseOn>,N,0,<couponLimit>,A

    try {
        if (action === 'create') {
            let promoText = ''
            if (computedTriggerLabel === 'for_every' && couponPrintAsOne) promoText += 'PRINTONCE,'
            promoText += `${computedTriggerAmount || 0}`
            promoText += `,${moment().format("DD/MM/YYYY")}`
            promoText += `,${computedBaseOn === 'selected_items_amount' ? 'S' : 'R'}`
            promoText += `,N` // Fixed
            promoText += `,0` // Fixed
            promoText += `,${computedTriggerLabel === 'for_every' ? couponLimit : 0}`
            promoText += `,A`
            return promoText
        } else if (action === 'update') {
            const promoTextArr = promoText.split(',');
            if (promoTextArr.length > 0) {
                if (promoText.includes("PRINTONCE")) {
                    return {
                        computed_coupon_limit: promoTextArr[6],
                        computed_coupon_base_on: promoTextArr[3] === 'S' ? 'selected_items_amount' : 'receipt_amount',
                        computed_coupon_print_as_one: true,
                        computed_trigger_amount: promoTextArr[1],
                    }
                } else {
                    return {
                        computed_coupon_limit: 0,
                        computed_coupon_base_on: promoTextArr[2] === 'S' ? 'selected_items_amount' : 'receipt_amount',
                        computed_coupon_print_as_one: false,
                        computed_trigger_amount: promoTextArr[0],
                    }
                }
            } else {
                throw new Error('Invalid promo text.')
            }
        } else {
            throw new Error('Action undefined.')
        }
    } catch (e) {
        console.log(e.message)
        return null
    }
}

const formatCurrency = (value) => {
    // Treat null/undefined and empty/whitespace strings as 0. Without the
    // empty-string guard, parseFloat('') is NaN and NaN.toFixed(2) returns the
    // string "NaN", which leaked into the ROUND column and failed validation.
    if (value == null || String(value).trim() === '' || isNaN(value)) return "0"

    let num = parseFloat(value)

    if (isNaN(num)) return "0"

    if (Number.isInteger(num)) return num.toString()

    return parseFloat(num.toFixed(2)).toString()
}

const lineRoundToNearest = (action, description = null) => {
    try {
        if (action === 'create') {

            description = description && description.trim() !== '' ? Number(description) : 0

            if (!_.isEmpty(description) || parseFloat(description) > 0) {
                return {
                    text: `^${formatCurrency(description)}`,
                    desc: ` Round up ${formatCurrency(description)}`,
                }
            }
            return { text: '', desc: '' }
        } else if (action === 'update') {
            const part = description.split(':')[2] || ''
            const match = part.match(/\^([\d.]+)/)
            // No "^" round-up marker means "no rounding" => 0, not blank/NaN.
            const roundUpVal = match ? match[1] : '0'
            return { text: formatCurrency(roundUpVal), desc: '' }
        } else {
            throw new Error('Action undefined.')
        }
    } catch (e) {
        console.log(e.message)
        return { text: '', desc: '' }
    }
}

const extractDetailPromoText = (promoType = 'GROUPBONUS', rewardSymbol = 'PERCENTAGE', description = '') => {
    try {
        if (promoType === 'GROUPBONUS') {
            let discountType = '';
            let exponentMatch = 0;

            const promoMatch = description.split(";")[0].split(":")[1].split("^")

            if(rewardSymbol == '%') {
                discountType = promoMatch[0].replace("%","")
                exponentMatch = promoMatch[1]
            } else if (rewardSymbol == 'L') {
                discountType = promoMatch[0].replace("L","")
                exponentMatch = promoMatch[1]
            } else if (rewardSymbol == 'F') {
                discountType = promoMatch[0].replace("F","")
                exponentMatch = promoMatch[1]
            }

            return {
                discountType: discountType,
                exponent: exponentMatch
            }
        }

        throw new Error(`Unknown Type: ${promoType}`)
    } catch (e) {
        console.log(e.message)
        return { discountType: '', exponentMatch: 0 }
    }
}

export {
    parseCouponPromoText,
    formatCurrency,
    lineRoundToNearest,
    extractDetailPromoText
}


// const testCouponText = parseCouponPromoText(this.promo.computed_coupon_base_on,
//     this.promo.computed_coupon_limit,
//     this.promo.computed_trigger_amount,
//     this.promo.computed_coupon_print_as_one
// )
// console.log("Promo Coupon Text:",testCouponText)